import React from 'react';
import ModuleMenuHeader from '../ModuleMenuHeader';
import ModuleMenuContent from '../ModuleMenuContent';

const ModuleMenuServer = () => {
    return (
        <>
            <ModuleMenuHeader />
            <ModuleMenuContent />
        </>
    );
};

export default ModuleMenuServer;
